<template>
  <div class="mt-4 grid grid-cols-1">
    <p class="text-sm text-gray-600">{{ product.description }}</p>
    <div class="mt-4">
      <account-users @update="updateUsers" :users="users" :app="product.app" />
      <div class="grid grid-cols-2 w-1/3 items-center gap-2">
        <label
          for="purchase-qty"
          class="text-sm uppercase text-gray-700 font-bold"
        >
          Qty
        </label>
        <m-input
          id="purchase-qty"
          type="number"
          v-model="qty"
          state="disabled"
        />
        <span class="text-sm uppercase text-gray-700 font-bold">Total</span>
        <span class="font-normal">{{ ((qty * price) / 100) | dollar }}</span>
      </div>
    </div>
    <div class="mt-6" v-if='!isPostPaid'>
      <h3 class="text-sm uppercase text-gray-700 font-bold">Payment Details</h3>
      <pay-purchase
        :paymentMethod="paymentMethod"
        :product="product"
        :priceID="priceID"
        :stripe="stripe"
        :qty="qty"
        :users="cognitoUsers"
        @updatedCard="loadPaymentMethod"
        @purchased="loadUsers"
      />
    </div>
    <div class="mt-6" v-else>
      <h3 class="text-sm uppercase text-gray-700 font-bold">Post paid Account</h3>
      <div class='mt-4 bg-white rounded-md shadow-sm -space-y-px'> This account has been registered
        with Heffron as a post paid account. All purchases made will be billed
        on account and reflected in your organisation’s next invoice.
      </div>
      <postpaid-purchase
        :paymentMethod="paymentMethod"
        :product="product"
        :priceID="priceID"
        :stripe="stripe"
        :qty="qty"
        :users="cognitoUsers"
        @updatedCard="loadPaymentMethod"
        @purchased="loadUsers"
      />
    </div>
  </div>
</template>

<script>
import { Stripe } from '@/app/utils/account/stripe';
import { API, ENDPOINTS } from '@/app/services/api-url';
import PayPurchase from './pay-purchase/pay-purchase.vue';
import AccountUsers from './account-users/account-users.vue';
import PostpaidPurchase from './postpaid-purchase/postpaid-purchase.vue';

export default {
  name: 'purchase',
  components: {
    PostpaidPurchase,
    PayPurchase,
    AccountUsers,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stripe: null,
      paymentMethod: null,
      users: [],
      selectedUsers: [],
    };
  },
  computed: {
    activeAccount() {
      return this.$store.getters['account/getActiveAccount'];
    },
    accountID() {
      return this.$store.getters['account/getActiveAccount'].uuid;
    },
    isPostPaid() {
      return this.$store.getters['account/hasAppSubscription']('POSTPAID') ? this.$store.getters['account/hasAppSubscription']('POSTPAID') : false;
    },
    priceID() {
      return this.product.prices[0].id;
    },
    price() {
      return this.product.prices[0].unit_amount;
    },
    qty() {
      return this.selectedUsers.length;
    },
    cognitoUsers() {
      return this.selectedUsers.map(user => user.cognitoID);
    },
  },
  methods: {
    async refreshAccount() {
      await this.$store.dispatch('account/refreshAccounts');
    },
    async loadPaymentMethod() {
      await this.refreshAccount();
      const { uuid, paymentMethodID } = this.activeAccount;
      if (paymentMethodID) {
        return API.get(
          `${ENDPOINTS.GET_STRIPE_PAYMENT_METHOD}/${paymentMethodID}?accountID=${uuid}`,
        )
          .then((response) => {
            if (response.status === 200) {
              this.paymentMethod = response.data.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      return false;
    },
    updateUsers(users) {
      this.selectedUsers = users;
    },
    loadUsers() {
      this.selectedUsers = [];
      API.get(`${ENDPOINTS.GET_ACCOUNTS}/${this.accountID}/accountuser`)
        .then((res) => {
          this.users = res.data.data;
        })
        .catch(err => console.log(err));
    },
  },
  async mounted() {
    this.stripe = await Stripe(this.$store);
    this.loadUsers();
    await this.loadPaymentMethod();
  },
};
</script>
